export default __webpack_public_path__ + "static/media/usdc_sol.1f9abb6e.svg";